import {http} from '../core/http';

export const userService = {
  async getCurrentUser() {
    return http.post('/uss/get_permission', {});
  },
};